import {NgModule} from '@angular/core';


import {FlexLayoutModule} from '@angular/flex-layout';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatSortModule} from '@angular/material/sort';
import {MatCardModule} from '@angular/material/card';
import {MatTableModule} from '@angular/material/table';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatIconModule} from '@angular/material/icon';
import {MatDialogModule} from '@angular/material/dialog';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatSliderModule} from '@angular/material/slider';
import {MatTabsModule} from '@angular/material/tabs';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatListModule} from '@angular/material/list';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatMenuModule} from '@angular/material/menu';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatStepperModule} from '@angular/material/stepper';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatChipsModule} from '@angular/material/chips';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatInputModule} from '@angular/material/input';

@NgModule({
    imports: [
        MatButtonModule,
        MatButtonToggleModule,
        MatToolbarModule,
        MatTableModule,
        MatCardModule,
        MatCheckboxModule,
        MatSortModule,
        MatDialogModule,
        MatIconModule,
        MatSnackBarModule,
        MatExpansionModule,
        MatGridListModule,
        MatSliderModule,
        MatTabsModule,
        MatFormFieldModule,
        MatListModule,
        MatSlideToggleModule,
        MatMenuModule,
        MatTooltipModule,
        MatSidenavModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatSelectModule,
        MatStepperModule,
        MatDatepickerModule,
        MatChipsModule,
        MatAutocompleteModule,
        MatPaginatorModule,
        MatInputModule,
        FlexLayoutModule
    ],
    exports: [
        MatButtonModule,
        MatButtonToggleModule,
        MatToolbarModule,
        MatTableModule,
        MatCardModule,
        MatCheckboxModule,
        MatSortModule,
        MatDialogModule,
        MatIconModule,
        MatSnackBarModule,
        MatExpansionModule,
        MatGridListModule,
        MatSliderModule,
        MatTabsModule,
        MatFormFieldModule,
        MatListModule,
        MatSlideToggleModule,
        MatMenuModule,
        MatTooltipModule,
        MatSidenavModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatSelectModule,
        MatStepperModule,
        MatDatepickerModule,
        MatChipsModule,
        MatAutocompleteModule,
        MatPaginatorModule,
        MatInputModule,
        FlexLayoutModule
    ]
})
export class MaterialModule {
}
